import { useEffect, useState } from "react";
import { apiGetFooterSocialLinks } from "../api/controllers/get-footer-socials";
import { ISocialAttributes } from "../api/types";

const Footer = () => {
  const [s, setS] = useState<ISocialAttributes | undefined>();
  useEffect(() => {
    apiGetFooterSocialLinks()
      .then((r) => setS(r.data?.[0]?.attributes))
      .catch(() => {});
  }, []);

  return (
    <footer className="site-footer">
      <span>© {new Date().getFullYear()} Josh Brett</span>
      <nav>
        {s?.YouTube && (
          <a href={s.YouTube} target="_blank" rel="noreferrer">
            YouTube
          </a>
        )}
        {s?.Instagram && (
          <a href={s.Instagram} target="_blank" rel="noreferrer">
            Instagram
          </a>
        )}
        {s?.Email && <a href={`mailto:${s.Email}`}>Email</a>}
      </nav>
    </footer>
  );
};

export default Footer;
